$(function ()
{
    const isDesktop = window.matchMedia("(min-width: 768px)").matches;

    //<editor-fold desc="Fix Bug with Header Collapse">
    $("body").click();
    //</editor-fold>

    //<editor-fold desc="Header Abstand Anpassung am Body">
    setHeaderSpacing();
    
    //</editor-fold>

    //<editor-fold desc="Abstand nach oben anpassen da der Trustbadge sich später reinschiebt">
    if (!isDesktop)
    {
        var tsInterval = setInterval(function()
        {

            if ($("#tsbadgeResponsiveTop_db8d3657bdbe440c985ae127463eaad4").length)
            {
                $("#tsbadgeResponsiveTop_db8d3657bdbe440c985ae127463eaad4").prependTo(".header__wrapper");

                var mt = document.getElementById("vue-app").style.marginTop;
                mt = parseInt(mt) + 53;

                document.getElementById("vue-app").style.marginTop = mt + "px";
                document.getElementById("vue-app").style.minHeight = "calc(100vh - " + mt + "px)";

                clearInterval(tsInterval);
            }

        }, 250);
    }
    //</editor-fold>

    //<editor-fold desc="header search icon scroll">
    $(".header-search-icon-scroll").click(function()
    {
        if (window.innerWidth < 992)
        {
            $(".header__wrapper").toggleClass("search-visible");
            $("body").toggleClass("search-visible");
        }
        else
        {
            $(".header__wrapper").toggleClass("search-visible--lg");
            $("body").toggleClass("search-visible--lg");
        }
    });
    //</editor-fold>

    //<editor-fold desc="mainmenu">
    let navBarHeader = document.getElementsByClassName("mainmenu"); // war mainmenu__item show-bg
    let navSearch = document.querySelector(".search-box");
    let pb = document.getElementById("page-body");
    if (navBarHeader.length > 0)
    {
        for (let key in navBarHeader)
        {
            if (navBarHeader.hasOwnProperty(key))
            {
                if (navBarHeader[key])
                {
                    navBarHeader[key].addEventListener("mouseenter", headerNavMouseEnterEvent, false);
                    navBarHeader[key].addEventListener("mouseleave", function(event)
                    {
                        setTimeout(function()
                        {
                            document.getElementById("page-body").classList.remove("background-active");
                        }, 1);
                    });
                }
            }
        }
    }
    pb.addEventListener("mousemove", function()
    {
        if (pb.classList.contains("background-active"))
        {
            document.getElementById("page-body").classList.remove("background-active");
        }
    });
    if(!!navSearch)
    {
        navSearch.addEventListener("mouseenter", function()
        {
            setTimeout(function()
            {
                document.getElementById("page-body").classList.remove("background-active");
            }, 250);
        });
    }
    document.addEventListener("mouseleave", function()
    {
        setTimeout(function()
        {
            document.getElementById("page-body").classList.remove("background-active");
        }, 350);
    });
    function headerNavMouseEnterEvent(event)
    {
        setTimeout(function()
        {
            document.getElementById("page-body").classList.add("background-active");
        }, 300);
    }
    //</editor-fold>

    //<editor-fold desc="mutation observer">
    var observeDOM = (function()
    {
        var MutationObserver = window.MutationObserver || window.WebKitMutationObserver;

        return function(obj, callback)
        {
            if (!obj || !obj.nodeType === 1) return; // validation

            if (MutationObserver)
            {
                // define a new observer
                var obs = new MutationObserver(function(mutations, observer)
                {
                    callback(mutations);
                });
                // have the observer observe foo for changes in children
                obs.observe(obj, { childList: true, subtree: true });
            }

            else if (window.addEventListener)
            {
                obj.addEventListener("DOMNodeInserted", callback, false);
                obj.addEventListener("DOMNodeRemoved", callback, false);
            }
        };
    })();
    observeDOM($(".header__wrapper")[0], function(m)
    {
        setHeaderSpacing();
    });
    function setHeaderSpacing()
    {
        var headerHeight = $(".header__wrapper").height();

        if ($("html").scrollTop() > 0)
        {
            if ($(".header__custom-banner").length)
            {
                headerHeight = 166;
            }
            else
            {
                headerHeight = 125;
            }
        }
        $("#vue-app").attr("style", "margin-top: " + headerHeight + "px; min-height: calc(100vh - " + headerHeight + "px);");
    }
    //</editor-fold>
})
